<app-header></app-header>

<ion-content scrollbar>
  <app-loading-sti *ngIf="loading"></app-loading-sti>
  <div *ngIf="!p.renderMobile" class="breadcrumb-margin">
    <app-breadcrumb></app-breadcrumb>
  </div>
  <ng-container *ngIf="!isError; else HTTPError">
    <ion-grid *ngIf="!loading">
      <ion-row class="margin-minus-20-mobile">
        <ion-col [attr.offset-xl]="buildingId ? '' : '3'" size-xl="6">
          <app-card [title]="headerInit.title">
            <form [formGroup]="form" (ngSubmit)="onSaveBuilding()">
              <app-input
                type="input"
                [form]="form"
                formControlName="name"
                [readonly]="checkReadonly()"
                label="BUILDING.NAME"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="textarea"
                [form]="form"
                formControlName="description"
                [autoGrow]="true"
                [readonly]="checkReadonly()"
                label="BUILDING.DESCRIPTION"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="input"
                [form]="form"
                formControlName="street"
                [readonly]="checkReadonly()"
                label="BUILDING.STREET"
                [submittedError]="validationError"
              ></app-input>

              <app-input
                type="text"
                [form]="form"
                formControlName="postCode"
                [readonly]="checkReadonly()"
                placeholder="_ _-_ _ _"
                [maskitoOptions]="postCodeMaskOptions"
                label="BUILDING.POSTCODE"
                maxlength="6"
                [submittedError]="validationError"
                ></app-input>
              <app-input
                type="input"
                [form]="form"
                formControlName="city"
                [readonly]="checkReadonly()"
                label="BUILDING.CITY"
                [submittedError]="validationError"
              ></app-input>

              <ion-item class="input" lines="none" *appHasRole="['building.edit']">
                <app-upload-attachment
                  [attachment]="building?.image?.filePath?.length ? building?.image : null"
                  (attachmentUploaded)="imageUploaded($event)"
                  (attachmentRemoved)="imageRemoved($event)"
                >
                </app-upload-attachment>
              </ion-item>
              <ion-label
                *ngIf="form.get('itemImage').hasError('fileMaxSize') && (form.get('itemImage').touched || validationError)"
                color="danger"
                class="font-size__16"
              >
                {{"SPACE.MAX_SIZE_VALIDATION"|translate}}
              </ion-label>
              <ion-label
                *ngIf="form.get('itemImage').hasError('fileFormat')"
                color="danger"
                class="font-size__16"
              >
                <div>
                  {{ "FILE_TYPE_VALIDATION_1" | translate }}
                  "{{form.get('itemImage').errors.fileFormat.actualFormat}}". {{
                  "FILE_TYPE_VALIDATION_2" | translate }}
                </div>
              </ion-label>

              <ion-item class="input" lines="none">
                <ng-container *ngIf="buildingId && !p.renderMobile">
                  <ion-button
                    *appHasRole="['building.edit']"
                    class="button-margin-top-md"
                    slot="start"
                    fill="outline"
                    size="medium"
                    color="primary"
                    (click)="deleteBuilding()"
                    >{{ 'DELETE' | translate}}</ion-button
                  >
                </ng-container>
                <ng-container *appHasRole="['building.edit']">
                  <ion-button
                    class="button-margin-top-md"
                    slot="end"
                    size="medium"
                    color="secondary"
                    (click)="backToBuildingList()"
                    *ngIf="!p.renderMobile"
                    >{{ 'CANCEL' | translate}}</ion-button
                  >
                  <ion-button
                    type="submit"
                    class="button-margin-top-md"
                    size="medium"
                    slot="end"
                    [disabled]="disableSaveButton"
                  >
                    <ng-container *ngIf="!disableSaveButton"
                      >{{'SAVE' | translate}}</ng-container
                    >
                    <ng-container *ngIf="disableSaveButton"
                      >{{'SAVING' | translate}}</ng-container
                    >
                  </ion-button>
                </ng-container>
              </ion-item>
            </form>
          </app-card>
        </ion-col>
        <ion-col size-xl="6" size="12" *ngIf="buildingId">
          <app-card
            title="{{'BUILDING.FLOORS' | translate }}"
            hideHeaderBreakpoint="700"
          >
            <app-pagination-client-side
              [componentRef]="componentRef"
              [columns]="floorsColumns"
              [options]="options"
              (rowsLoaderReady)="floorsRowsLoaderServiceReady($event)"
              (actionRequest)="handleActionRequest($event)"
              (headerEmitClick)="addFloor()"
              (refreshRequest)="RefreshFloors()"
            >
            </app-pagination-client-side>
          </app-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ng-container>
  <ng-template #HTTPError>
    <app-api-not-found
      name="BUILDING.BUILDING"
      link="app/building"
      returnText="BUILDING.RETURN_TU_BUILDING_LIST"
      [status]="errorStatus"
    >
    </app-api-not-found>
  </ng-template>
</ion-content>
